import { onMounted, onBeforeUnmount, ref } from 'vue'
import constants from '../lib/constants'
import { setViewportName } from '../lib/lib'

// this composable can be used to check which viewport type is being show
export default function useViewport() {
  const viewportType = ref('')
  const desktop = ref(true)
  const tablet = ref(false)
  const mobile = ref(false)

  onMounted(() => {
    setViewportName()
    assignCurrentViewport()
    window.addEventListener('resize', () => {
      setViewportName()
      assignCurrentViewport()
    })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', () => {})
  })

  const assignCurrentViewport = () => {
    viewportType.value = constants.is
    desktop.value = viewportType.value === 'desktop'
    tablet.value = viewportType.value === 'tablet'
    mobile.value = viewportType.value === 'mobile'
  }

  return {
    viewportType,
    desktop,
    tablet,
    mobile,
  }
}
